module.exports = "<div class=\"login offset-md-4 col-md-4 white-background top-off\">\n\n  <div  style=\"width: 300px; margin: 20px 0;\">\n    <img src=\"/assets/img/fastnet-logo-trans.png\" />\n  </div>\n  <div class=\"eval_form\">\n    <login-form></login-form>\n  </div>\n  <a href=\"http://www.rockalltech.com\"><img src=\"/assets/img/rockall_logo_with_lens_flare.png\" height=\"50px\" /></a>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/login.component.html
 ** module id = 67
 ** module chunks = 0
 **/